module.exports = __webpack_public_path__ + "static/media/logo.0ad19889.svg";